export const InspectionActionTypes = {
    GET_INSPECTION_FORM: 'GET_INSPECTION_FORM',
    GET_INSPECTIONS: 'GET_INSPECTIONS',
    GET_INSPECTION_DETAIL: 'GET_INSPECTION_DETAIL',
    SET_INSPECTION_QUERIES: 'SET_INSPECTION_QUERIES',
}
